import { render } from "./NcrmNotificationCenter.vue?vue&type=template&id=055abf9a&scoped=true"
import script from "./NcrmNotificationCenter.vue?vue&type=script&lang=js"
export * from "./NcrmNotificationCenter.vue?vue&type=script&lang=js"

import "./NcrmNotificationCenter.css?vue&type=style&index=0&id=055abf9a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055abf9a"]])

export default __exports__